import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import { loginIn } from './getData';
import { LOGIN_IN } from './mutation-types'
import { isZnWebsite } from '../utils/isChinaWebsite';

Vue.use(Vuex);

import mutations from './mutation'
import actions from './action'

// 判断语言

export default new Vuex.Store({
  state: {
    isZnWebsite,
    country: "",
    sitekey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
    account: {
      email: '',  //  用户登录邮箱
      loginSuccess: '', //登录
      loginStatus: false, // 记录登录状态
    },
    signUp: {
      isSignUpDisable: false, //  记录注册状态
    },
    inviteCode: {
      status: false, //邀请码是否可领取状态
      codeList: '', //邀请list
      mainland_list: '', //邀请list
      non_mainland_list: '', //邀请list
      calculate_list: '', //计算list	
    },
    hardWare: {
      hardLength: '',
      deviceSize: '',
      currentPage: 1,
      hardList: '',
      allDevices: [] //所有设备列表，帮助搜索
    },
    revenue: {
      // inviteRevenue: '', // 邀请收益
      // accountRevenue: '', // 个人收益
      // allRenvue: '', //用户总收益

      balance: 0,
      totalInvite: 0,
      totalNetRevenue: 0,
      totalOnlineRevenue: 0,
      totalRevenue: 0,
    },
    revenueDetail: {
      currentPage: '',
      deviceLength: '',
      deviceNumSize: 1,
      revenueDetail: [],
      allDevices: [],
      detailBxc: '-',
      detailTaskBxc: '-',
      detailOnlineBxc: '-'
    },
    inviteDetail: {
      detailList: [],
      pageSize: 1,
      currentPage: '',
      length: ''
    },
    recommend: {
      recommendRefer: '', //  用户推荐refer
      count: '' //  用户推荐数
    },
    wallet: {
      address: '',
      eth_verify_status: ''
    },
    withdrawal: {
      list: [],
      balance: '',
      commitStatus: "done" //默认全部提现操作完成
    },
    networkContribution: [], //全网前100收益
    device: {
      overview: {},
      filterType: '', //设备筛选
      pageNum: 1
    },
    buyBack: {
      buyBackList: [],
      lastSevenPrice: '',
      addressStatus: '', //usdt充值码生成状态
      auth: false,
      BUYBACK_COUNT: ''
    },
    wechat: {
      openid: '',
      emails: [],
      revenues: [],
      deviceInfos: [],
      // 公众号提现有关⬇️
      balance:'',
      RMBPrice:'',
      BUYBACK_COUNT:'',
      BUYBACK_MONEY_COUNT:'',
      TYPE_1_SHUI:'',
      TYPE_2_SHUI:'',
      TYPE_3_SHUI:'',
      discount:'',
      maxAmount:'',
      minAmount:'',
    },
    standardNode: {
      dialConfig: [],
      nodeConfig: []
    },
    exchange: {
      balance: '',
      RMBPrice: "",
      canExchangeCount: {},
      canExchangeMoney: [],
      exchangeList: []
    },
    dialStatus: {
      serverList: ''
    },


    bill:{
      business:[],
    }
  },
  mutations,
  actions,
});

